import ButtonPrimary from 'components/ButtonPrimary'
import Text from 'components/Text'
import { View } from 'components/View'
import formatMessageIntlUtil from 'modules/intl/utils/format-message'
import React from 'react'
import { defineMessages } from 'react-intl'
import useIntl from 'modules/component/utils/hooks/useIntl'
import Button from 'components/Button/index.js'
import { ArrowLeftIcon } from 'components/Icon/icons/arrow-left/index.js'
import TextTitleCondensed from 'components/TextTitleCondensed.js'
import { LoadingIcon } from 'components/Icon/icons/loading/index.js'
import Form from 'components/Form/index.js'
import Input from 'components/Input/index.js'
import Link from 'components/Link/index.js'
import { ROUTE_PATH } from 'modules/routes/constants/index.cjs'
import { logUtil } from 'packages/src'
import isEmailStringUtil from 'utils/string/is-email/index.js'
import updatePasswordTrainingAuthAction from 'modules/training/modules/app-auth/actions/update-password/index.js'
import useDispatch from 'modules/component/utils/hooks/useDispatch.js'
import TextBodySmall from 'components/TextBodySmall/index.js'

const messages = defineMessages({
  emailOrName: {
    id: 'SigninSignupFlowSignInSignUp.emailOrName',
    defaultMessage: 'Email or name'
  },
  password: {
    id: 'SigninSignupFlowSignInSignUp.password',
    defaultMessage: 'Password'
  },
  forgotPassword: {
    id: 'SigninSignupFlowSignInSignUp.forgotPassword',
    defaultMessage: 'Forgot Password?'
  },
  next: {
    id: 'SigninSignupFlowSignInSignUp.next',
    defaultMessage: 'NEXT'
  },
  back: {
    id: 'SigninSignupFlowSignInSignUp.back',
    defaultMessage: 'Back'
  },
  email: {
    id: 'SigninSignupFlowSignInSignUp.email',
    defaultMessage: 'Email'
  },
  name: {
    id: 'SigninSignupFlowSignInSignUp.name',
    defaultMessage: 'Name'
  },
  privacyPolicyTextPart1: {
    id: 'SigninSignupFlowSignInSignUp.privacyPolicyTextPart1',
    defaultMessage: 'By signing up you’re agreeing to our'
  },
  privacyPolicyTextPart2: {
    id: 'SigninSignupFlowSignInSignUp.privacyPolicyTextPart2',
    defaultMessage: 'Policy Privacy'
  },
  privacyPolicyTextPart3: {
    id: 'SigninSignupFlowSignInSignUp.privacyPolicyTextPart3',
    defaultMessage: 'Terms & Conditions'
  },
  and: {
    id: 'SigninSignupFlowSignInSignUp.and',
    defaultMessage: ' and'
  },
  signIn: {
    id: 'SigninSignupFlowSignInSignUp.signIn',
    defaultMessage: 'SIGN IN'
  },
  signUp: {
    id: 'SigninSignupFlowSignInSignUp.signUp',
    defaultMessage: 'SIGN UP'
  },
  createAnAccountToGetYourPersonalizedPlan: {
    id: 'SigninSignupFlowSignInSignUp.createAnAccountToGetYourPersonalizedPlan',
    defaultMessage: 'Create an account to get your personalized plan'
  }
})

export default function SigninSignupFlowSignInSignUp (props) {
  const intl = useIntl()
  const dispatch = useDispatch()

  const handleChangePassword = (event) => {
    dispatch(updatePasswordTrainingAuthAction(event.target.value))
  }

  const {
    emailOrName,
    isEmailVisible,
    isEmail,
    exists,
    isEmailOrNameValid,
    email,
    handleClickBack,
    title,
    loading,
    handleChangeEmailOrName,
    setIsInvalidEmailOrNameField,
    isInvalidEmailOrNameField,
    handleChangeEmail,
    isPasswordVisible,
    password,
    setIsForgotPasswordVisible,
    handleClickSubmit,
    isOnboarding
  } = props

  const isFormValid = () => {
    const debugProps = {
      exists,
      email,
      isEmailOrNameValid
    }
    logUtil('SigninSignupFlowSignInSignUp#isFormValid').debug('debugProps=', debugProps)
    if (exists === null) {
      return isEmailOrNameValid
    }

    const isValidEmail = isEmailStringUtil(email)
    if (isEmailVisible && isPasswordVisible) {
      return isValidEmail && password
    }
    if (isEmailVisible) {
      return isValidEmail
    }

    return isEmailOrNameValid && password
  }

  let emailOrNamePlaceholderMessage
  if (isEmailVisible) {
    emailOrNamePlaceholderMessage = messages.name
  } else if (isEmail) {
    emailOrNamePlaceholderMessage = messages.email
  } else {
    emailOrNamePlaceholderMessage = messages.emailOrName
  }

  const handleBlurEmailOrName = () => {
    setIsInvalidEmailOrNameField(!isEmailOrNameValid && emailOrName.length > 0)
  }

  return (
    <>
      {
        exists !== null && (
          <Button onClick={handleClickBack}>
            <View
              row
              ac
            >
              <ArrowLeftIcon style={{
                width: '0.95em',
                height: '0.95em'
              }}
              />
              <Text
                ml='4px'
                fs='0.75em'
                c='#000000'
              >{formatMessageIntlUtil(intl, messages.back)}
              </Text>
            </View>
          </Button>
        )
      }

      <View
        row
        style={{ justifyContent: 'space-between' }}
      >
        <TextTitleCondensed
          fw='700'
          fs='1.125em'
          c='#151D21'
          style={{
            textAlign: 'left',
            width: '90%'
          }}
        >
          {title}
        </TextTitleCondensed>
        {loading && (
          <LoadingIcon
            stroke='black'
            style={{
              width: '30px',
              height: '30px'
            }}
          />
        )}
      </View>

      {
        !!isOnboarding && (
          <TextBodySmall>
            {formatMessageIntlUtil(intl, messages.createAnAccountToGetYourPersonalizedPlan)}
          </TextBodySmall>
        )
      }

      <Form>
        <Input
          isFocused={exists == null}
          isDisabled={exists !== null}
          type='text'
          value={emailOrName}
          placeholder={formatMessageIntlUtil(intl, emailOrNamePlaceholderMessage)}
          onChange={handleChangeEmailOrName}
          onBlur={handleBlurEmailOrName}
          style={{
            background: '#F6F6F6',
            color: '#151D21',
            borderRadius: '8px',
            border: isInvalidEmailOrNameField ? '1px solid red' : 'none',
            padding: '10px 13px',
            marginTop: '16px'
          }}
        />

        {
          !!isEmailVisible && (
            <Input
              isFocused={!email}
              value={email}
              placeholder={formatMessageIntlUtil(intl, messages.email)}
              onChange={handleChangeEmail}
              style={{
                background: '#F6F6F6',
                color: '#151D21',
                borderRadius: '8px',
                border: 'none',
                padding: '10px 13px',
                marginTop: '16px'
              }}
            />
          )
        }

        {
          !!isPasswordVisible && (
            <Input
              isFocused={!password}
              type='password'
              value={password}
              placeholder={formatMessageIntlUtil(intl, messages.password)}
              onChange={handleChangePassword}
              style={{
                background: '#F6F6F6',
                color: '#151D21',
                borderRadius: '8px',
                border: 'none',
                padding: '10px 13px',
                marginTop: '16px'
              }}
            />
          )
        }

        {
          exists === false &&
          isPasswordVisible && (
            <View
              mt='16px'
            >
              <Text
                fs='0.875em'
                c='#151D21'
                style={{
                  lineHeight: '18px',
                  textAlign: 'left'
                }}
              >
                {formatMessageIntlUtil(intl, messages.privacyPolicyTextPart1)}
                <Link
                  to={ROUTE_PATH.PRIVACY}
                  target='_blank'
                >
                  <span style={{
                    textDecoration: 'underline',
                    marginLeft: '4px'
                  }}
                  >{formatMessageIntlUtil(intl, messages.privacyPolicyTextPart2)}
                  </span>
                </Link>
                {' '}
                {formatMessageIntlUtil(intl, messages.and)}
                <Link
                  to={ROUTE_PATH.APP_TERMS}
                  target='_blank'
                >
                  <span style={{
                    textDecoration: 'underline',
                    marginLeft: '4px'
                  }}
                  >{formatMessageIntlUtil(intl, messages.privacyPolicyTextPart3)}
                  </span>
                </Link>
              </Text>
            </View>
          )
        }
        {exists && isPasswordVisible && (
          <View style={{ alignItems: 'flex-end' }}>
            <Button
              type='button'
              onClick={() => setIsForgotPasswordVisible(true)}
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                marginTop: '18px',
                height: 'unset',
                width: 'fit-content'
              }}
            >
              <Text
                c='#151D21'
                fs='0.875em'
                style={{
                  textDecoration: 'underline',
                  textAlign: 'right'
                }}
              >
                {formatMessageIntlUtil(intl, messages.forgotPassword)}
              </Text>
            </Button>
          </View>
        )}

        <View>
          <ButtonPrimary
            isDisabled={!isFormValid() || loading}
            isFullWidth
            onClick={handleClickSubmit}
            style={{ marginTop: '34px' }}
          >
            <Text
              c='#ffffff'
              fs='0.9375em'
            >
              {!isPasswordVisible
                ? formatMessageIntlUtil(intl, messages.next)
                : exists
                  ? formatMessageIntlUtil(intl, messages.signIn)
                  : formatMessageIntlUtil(intl, messages.signUp)}
            </Text>
          </ButtonPrimary>
        </View>
      </Form>
    </>
  )
}
